import React from "react";

import V2Badge from "../../../v2/components/V2Badge";

import "./ChecklistStatusLegend.css";

const STATUSES = ["done", "flagged", "pending", "not_submitted"];

/**
 * The "45 items · 10 stores" label + the four status swatches, shown above
 * the matrix on both the Admin and Store Manager views. Doubles as a
 * multi-select filter: toggling a swatch tells ChecklistMatrixTable (via
 * the same `activeStatuses` set) which rows/cells to show or dim.
 */
export default function ChecklistStatusLegend({
  activeStatuses,
  onToggleStatus,
  totalItemCount,
  visibleItemCount,
  storeCount,
}) {
  const hasFilter = activeStatuses.size > 0;

  return (
    <div className="checklist-status-legend">
      <p className="checklist-status-legend-label">
        {hasFilter ? `${visibleItemCount} of ${totalItemCount}` : totalItemCount} items
        {storeCount !== undefined && ` · ${storeCount} stores`}
      </p>
      {STATUSES.map((status) => {
        const isActive = activeStatuses.has(status);
        return (
          <button
            key={status}
            type="button"
            className="checklist-status-filter"
            aria-pressed={isActive}
            onClick={() => onToggleStatus(status)}
          >
            <V2Badge status={status} dimmed={hasFilter && !isActive} />
          </button>
        );
      })}
    </div>
  );
}
